








































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'


import AppHeader from '@/components/app/AppHeader.vue'
import BuilderNavigationStep from '@/components/builder/BuilderNavigationStep.vue'
import BuilderSidebar from '@/components/builder/BuilderSidebar.vue'
import BuilderDeviceChatStub, { CmpChannel } from '@/components/builder/BuilderDeviceChatStub.vue'
import BuilderDefaultContainer from '@/components/builder/BuilderDefaultContainer.vue'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import WithBuilderStubProperties from '@/mixins/WithBuilderStubProperties'
import BuilderDot from "@/components/builder/BuilderDot.vue"
import DescriptionMobileMenu from '@/components/DescriptionMobileMenu.vue'


@Component({
  components: {
    AppHeader,
    BuilderDeviceChatStub,
    BuilderDefaultContainer,
    BuilderSidebar,
    BuilderNavigationStep,
    BuilderTooltip,
    BuilderButton,
    BuilderDot,
    DescriptionMobileMenu
    
  },
  created() {
    this.$store.dispatch('app/changeVisibilityMenu', true)
  },
  computed: {
    ...mapGetters('builder', {appType: 'getAppType'})
  }
})
export default class BuilderChatCreate extends Mixins(WithBuilderStubProperties) {
  @Prop({ default: false, type: Boolean }) loaded!: boolean
  
  appType!: string

  processing = false

  channels: CmpChannel[] = []

  get formattedChannels(): CmpChannel[] {
    return this.channels.map((c, i) =>
      i === 0 && !c.name.length ? { ...c, name: this.$t('generalChat').toString() } : c
    )
  }
  get chatName(): string {
    return this.appType === 'TYPE_BLOGER' ? this.$t('generalChat').toString() : `${this.$t('generalChat').toString()} ${this.$t('buyers').toString()}`
  }
  @Watch('stubChannels', { immediate: true, deep: true })
  async onStubChannelsChange(value: CmpChannel[]): Promise<void> {
    if (!value.length) {
      this.channels = [
        {
          id: -Number(Date.now().toString()),
          name: this.chatName,
          tariffs: [],
          image: null,
          highlight: 'chat',
        },
      ]
    } else {
      this.channels = value.map((c, i) => (i === 0 ? { ...c, highlight: 'chat' } : c))
    }
  }

  get title(): string {
    return this.channels[0]?.name ?? ''
  }

  set title(value: string) {
    this.channels = this.channels.map((c, i) => (i === 0 ? { ...c, name: value } : c))
  }
  get isNextStepDisabled(): boolean {
    return !this.title
  }

  async onNext(): Promise<void> {
    if (this.isNextStepDisabled) {
      return
    }
    if (this.title.length > 30) {
      this.$toasted.error(String(this.$t('errors.chats.count')))
      return
    }

    this.processing = true
    
    let id = 0
    if(this.channels[0]) {
      id = this.channels[0].id
    }

    await this.$store.dispatch('builder/mutateChannel', {
      name: this.title,
      id,
      type: 2
    })

    this.processing = false

    await this.$router.push({
      name: 'chat.public_avatar',
      params: { id: this.$route.params.id },
    })
  }
}
